import { IBloodDrive } from "../../../../types/IBloodDrive";
import { useEffect, useState } from "react";
import { getBloodDriveDataServiceInstance } from "../../../../services/bexWISE/bloodDriveDataService/getBloodDriveDataServiceInstance";
import {
   areOpportunitySearchQueriesEqual,
   OpportunitySearchLocationQuery,
   OpportunitySearchAccountQuery,
   OpportunitySearchQuery,
} from "../types/OpportunitySearchQuery";

interface IUseOpportunitySearch {
   loading: boolean;
   currentQuery: OpportunitySearchQuery | null;
   setQuery: (query: OpportunitySearchQuery) => void;
   searchResults: IBloodDrive[] | null;
}
interface IUseOpportunitySearchProps {
   defaultSearch: OpportunitySearchQuery;
}

export function useOpportunitySearchQuery(
   props: IUseOpportunitySearchProps,
): IUseOpportunitySearch {
   const [currentQuery, setCurrentQuery] = useState<OpportunitySearchQuery>(
      props.defaultSearch,
   );
   const [searchResults, setSearchResults] = useState<IBloodDrive[]>([]);
   const [loading, setLoading] = useState(true);

   const setQuery = (newQuery: OpportunitySearchQuery): void => {
      // If query changed, update
      if (!areOpportunitySearchQueriesEqual(currentQuery, newQuery)) {
         setCurrentQuery(newQuery);
      }
   };

   useEffect(() => {
      // Only use the API call if currentQueryValue is not undefined, not blank, or has more than 1 characters (SCREDP-44)
      const accountQuery = currentQuery as OpportunitySearchAccountQuery;
      const isAccountQuery = accountQuery.accountName !== undefined || // SCREDP-42: support optional account code and location code
                           accountQuery.accountCode !== undefined ||
                           accountQuery.locationCode !== undefined;

      const currentQueryValue = isAccountQuery
         ? accountQuery.accountName || accountQuery.accountCode || accountQuery.locationCode
         : (currentQuery as OpportunitySearchLocationQuery).origin;
      if (currentQueryValue !== "undefined" && typeof currentQueryValue === "string" && currentQueryValue.trim().length >= 1) {
            
            getBloodDriveDataServiceInstance()
               .getDrives(currentQuery)
               .then((results: IBloodDrive[]) => {
                  setSearchResults(results);
                  setLoading(false);
            });
      } else {
         setSearchResults([]);
         //setLoading(false);
      }
   }, [currentQuery]);

   return {
      loading,
      searchResults,
      currentQuery,
      setQuery,
   };
}
